<template>
    <v-text-field
      rounded
      dense
      v-model="search"
      :label="trans('Search')"
      outlined
      append-icon="mdi-magnify"
    ></v-text-field>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      awaitingSearch: false,
    };
  },
  watch: {
    search: function() {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.$parent.$root.search = this.search;
          Fire.$emit('searching');
          this.awaitingSearch = false;
        }, 700); // 700ms delay
      }
      this.awaitingSearch = true;
    },
  },
};
</script>

<style scoped>
.v-input {
  max-width: 300px !important;
  min-width: 300px !important;
}

::v-deep .v-input__control  .v-input__slot {
    min-height: 40px !important;
}

::v-deep .v-label {
  top: 10px !important;
}

::v-deep .v-input__control  .v-input__append-inner {
  margin-top: 8px !important;
}


::v-deep .v-text-field__details {
  display: none !important;
}

@media (max-width: 768px) {
  .v-input {
    max-width: 100% !important;
    min-width: auto !important;
  }
}
</style>
